import { actionCreator } from 'utils';
import {
    LOAD_RESELLERS,
    SET_RESELLERS_FILTER,
    SET_RESELLER_PAGINATION,
    SET_RESELLER_SORT,
    SET_EMPTY_EDITABLE_RESELLER,
    LOAD_EDITABLE_RESELLER,
    RESET_FILTER_RESELLERS,
    LOAD_RESELLER_SEGMENTS,
    LOAD_SEGMENTS_FOR_RESELLERS,
    SET_EMPTY_SEGMENTS_FOR_RESELLERS,
    LOAD_PRODUCT_GROUPS_FOR_RESELLERS,
    SET_PRODUCT_GROUPS_FILTER_FOR_RESELLERS,
    SET_PRODUCT_GROUPS_PAGINATION_FOR_RESELLERS,
    SET_ACTIVE_SEGMENT,
    ADD_SEGMENT_PRODUCT_GROUP,
    LOAD_EDITABLE_SEGMENT_FOR_RESELLERS,
    SET_EMPTY_EDITABLE_SEGMENT_FOR_RESELLERS,
    LOAD_EDITABLE_SEGMENT_PRODUCT_GROUP_FOR_RESELLERS,
    SET_EMPTY_ACTIVE_SEGMENT,
    RESET_PRODUCTS_GROUPS_FILTERS_FOR_RESELLERS,
    DELETE_SEGMENT_PRODUCT_GROUP,
    CHANGE_RESELLER_SEGMENT_ORDER,
    DELETE_INVOICE_TEMPLATE,
} from '../types/resellerTypes';

const initState = {
    loading: false,
    error: false,
    success: false,
    offset: 0,
    limit: 10,
    sort: {
        key: 'created_at',
        type: 'desc',
    },
    listing: {},
    add: {
        loading: false,
        error: false,
        success: false,
        current: 0,
    },
    edit: {
        loading: false,
        data: null,
        error: false,
        success: false,
    },
    deleteInvoiceTemplate: {
        loading: false,
        error: false,
        success: false,
    },
    segments: {
        loading: false,
        data: null,
        error: false,
        success: false,
        activeSegment: null,
        add: {
            loading: false,
            error: false,
            success: false,
        },
        edit: {
            loading: false,
            data: null,
            error: false,
            success: false,
            productGroup: {
                loading: false,
                data: null,
                error: false,
                success: false,
            },
        },
        delete: {
            loading: false,
            error: false,
            success: false,
        },
        order: {
            loading: false,
            error: false,
            success: false,
        },
    },
    listingSegmentsForResellers: {
        loading: false,
        data: null,
        error: false,
        success: false,
    },
    listingProductGroupsForResellers: {
        loading: false,
        data: null,
        error: false,
        success: false,
        offset: 0,
        limit: 10,
        filters: {
            name: '',
        },
    },
    filters: {
        name: '',
        domain: '',
        siteGroup: '',
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case LOAD_RESELLERS:
        return Object.assign({}, state, {
            loading: true,
        });

    case actionCreator(LOAD_RESELLERS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(LOAD_RESELLERS, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case SET_RESELLERS_FILTER:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case actionCreator(SET_RESELLERS_FILTER, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case SET_RESELLER_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case SET_RESELLER_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    case LOAD_EDITABLE_RESELLER:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(LOAD_EDITABLE_RESELLER, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(LOAD_EDITABLE_RESELLER, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: true,
            }),
        });

    case SET_EMPTY_EDITABLE_RESELLER:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: null,
                error: false,
            }),
        });

    case RESET_FILTER_RESELLERS:
        return Object.assign({}, state, {
            ...state,
            loading: true,
            filters: {
                name: '',
                domain: '',
                siteGroup: '',
            },
        });

    case actionCreator(RESET_FILTER_RESELLERS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case LOAD_RESELLER_SEGMENTS:
        return Object.assign({}, state, {
            segments: Object.assign({}, state.segments, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(LOAD_RESELLER_SEGMENTS, 'res'):
        return Object.assign({}, state, {
            segments: Object.assign({}, state.segments, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(LOAD_RESELLER_SEGMENTS, 'err'):
        return Object.assign({}, state, {
            segments: Object.assign({}, state.segments, {
                loading: false,
                error: true,
            }),
        });

    case LOAD_SEGMENTS_FOR_RESELLERS:
        return Object.assign({}, state, {
            listingSegmentsForResellers: Object.assign({}, state.listingSegmentsForResellers, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(LOAD_SEGMENTS_FOR_RESELLERS, 'res'):
        return Object.assign({}, state, {
            listingSegmentsForResellers: Object.assign({}, state.listingSegmentsForResellers, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(LOAD_SEGMENTS_FOR_RESELLERS, 'err'):
        return Object.assign({}, state, {
            listingSegmentsForResellers: Object.assign({}, state.listingSegmentsForResellers, {
                loading: false,
                error: true,
            }),
        });

    case SET_EMPTY_SEGMENTS_FOR_RESELLERS:
        return Object.assign({}, state, {
            listingSegmentsForResellers: Object.assign({}, state.listingSegmentsForResellers, {
                loading: false,
                data: null,
            }),
        });

    case LOAD_PRODUCT_GROUPS_FOR_RESELLERS:
        return Object.assign({}, state, {
            listingProductGroupsForResellers: Object.assign({}, state.listingProductGroupsForResellers, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(LOAD_PRODUCT_GROUPS_FOR_RESELLERS, 'res'):
        return Object.assign({}, state, {
            listingProductGroupsForResellers: Object.assign({}, state.listingProductGroupsForResellers, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(LOAD_PRODUCT_GROUPS_FOR_RESELLERS, 'err'):
        return Object.assign({}, state, {
            listingProductGroupsForResellers: Object.assign({}, state.listingProductGroupsForResellers, {
                loading: false,
                error: true,
            }),
        });

    case SET_PRODUCT_GROUPS_FILTER_FOR_RESELLERS:
        return Object.assign({}, state, {
            listingProductGroupsForResellers: Object.assign({}, state.listingProductGroupsForResellers, {
                loading: true,
                filters: {
                    ...state.filters,
                    [action.key]: action.value,
                },
            }),
        });

    case actionCreator(SET_PRODUCT_GROUPS_FILTER_FOR_RESELLERS, 'res'):
        return Object.assign({}, state, {
            listingProductGroupsForResellers: Object.assign({}, state.listingProductGroupsForResellers, {
                loading: false,
                data: action.data,
            }),
        });

    case RESET_PRODUCTS_GROUPS_FILTERS_FOR_RESELLERS:
        return Object.assign({}, state, {
            listingProductGroupsForResellers: Object.assign({}, state.listingProductGroupsForResellers, {
                loading: false,
                filters: {
                    name: '',
                },
            }),
        });

    case SET_PRODUCT_GROUPS_PAGINATION_FOR_RESELLERS:
        return Object.assign({}, state, {
            listingProductGroupsForResellers: Object.assign({}, state.listingProductGroupsForResellers, {
                [action.key]: action.pagination,
            }),
        });

    case SET_ACTIVE_SEGMENT:
        return Object.assign({}, state, {
            segments: Object.assign({}, state.segments, {
                activeSegment: action.data,
            }),
        });

    case SET_EMPTY_ACTIVE_SEGMENT:
        return Object.assign({}, state, {
            segments: Object.assign({}, state.segments, {
                activeSegment: null,
            }),
        });

    case ADD_SEGMENT_PRODUCT_GROUP:
        return Object.assign({}, state, {
            segments: Object.assign({}, state.segments, {
                add: {
                    loading: true,
                    error: false,
                },
            }),
        });

    case actionCreator(ADD_SEGMENT_PRODUCT_GROUP, 'res'):
        return Object.assign({}, state, {
            segments: Object.assign({}, state.segments, {
                add: {
                    loading: action.loading,
                    error: false,
                    success: action.success,
                },
            }),
        });

    case actionCreator(ADD_SEGMENT_PRODUCT_GROUP, 'err'):
        return Object.assign({}, state, {
            segments: Object.assign({}, state.segments, {
                add: {
                    loading: false,
                    error: action.error,
                },
            }),
        });

    case DELETE_SEGMENT_PRODUCT_GROUP:
        return Object.assign({}, state, {
            segments: Object.assign({}, state.segments, {
                delete: {
                    loading: true,
                    error: false,
                },
            }),
        });

    case actionCreator(DELETE_SEGMENT_PRODUCT_GROUP, 'res'):
        return Object.assign({}, state, {
            segments: Object.assign({}, state.segments, {
                delete: {
                    loading: action.loading,
                    error: false,
                    success: action.success,
                },
            }),
        });

    case actionCreator(DELETE_SEGMENT_PRODUCT_GROUP, 'err'):
        return Object.assign({}, state, {
            segments: Object.assign({}, state.segments, {
                delete: {
                    loading: false,
                    error: action.error,
                },
            }),
        });

    case CHANGE_RESELLER_SEGMENT_ORDER:
        return Object.assign({}, state, {
            segments: Object.assign({}, state.segments, {
                order: {
                    loading: true,
                    error: false,
                },
            }),
        });

    case actionCreator(CHANGE_RESELLER_SEGMENT_ORDER, 'res'):
        return Object.assign({}, state, {
            segments: Object.assign({}, state.segments, {
                order: {
                    loading: action.loading,
                    error: false,
                    success: action.success,
                },
            }),
        });

    case actionCreator(CHANGE_RESELLER_SEGMENT_ORDER, 'err'):
        return Object.assign({}, state, {
            segments: Object.assign({}, state.segments, {
                order: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case LOAD_EDITABLE_SEGMENT_FOR_RESELLERS:
        return Object.assign({}, state, {
            segments: Object.assign({}, state.segments, {
                edit: {
                    loading: true,
                    error: false,
                },
            }),
        });

    case actionCreator(LOAD_EDITABLE_SEGMENT_FOR_RESELLERS, 'res'):
        return Object.assign({}, state, {
            segments: Object.assign({}, state.segments, {
                edit: {
                    loading: false,
                    data: action.data,
                },
            }),
        });

    case actionCreator(LOAD_EDITABLE_SEGMENT_FOR_RESELLERS, 'err'):
        return Object.assign({}, state, {
            segments: Object.assign({}, state.segments, {
                edit: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case SET_EMPTY_EDITABLE_SEGMENT_FOR_RESELLERS:
        return Object.assign({}, state, {
            segments: Object.assign({}, state.segments, {
                edit: {
                    loading: false,
                    data: null,
                    error: false,
                },
            }),
        });

    case LOAD_EDITABLE_SEGMENT_PRODUCT_GROUP_FOR_RESELLERS:
        return Object.assign({}, state, {
            segments: Object.assign({}, state.segments, {
                edit: {
                    ...state.segments.edit,
                    productGroup: {
                        loading: true,
                        error: false,
                    },
                },
            }),
        });

    case actionCreator(LOAD_EDITABLE_SEGMENT_PRODUCT_GROUP_FOR_RESELLERS, 'res'):
        return Object.assign({}, state, {
            segments: Object.assign({}, state.segments, {
                edit: {
                    ...state.segments.edit,
                    productGroup: {
                        loading: false,
                        data: action.data,
                    },
                },
            }),
        });

    case actionCreator(LOAD_EDITABLE_SEGMENT_PRODUCT_GROUP_FOR_RESELLERS, 'err'):
        return Object.assign({}, state, {
            segments: Object.assign({}, state.segments, {
                edit: {
                    ...state.segments.edit,
                    productGroup: {
                        loading: false,
                        error: true,
                    },
                },
            }),
        });

    case DELETE_INVOICE_TEMPLATE:
        return Object.assign({}, state, {
            deleteInvoiceTemplate: Object.assign({}, state.deleteInvoiceTemplate, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(DELETE_INVOICE_TEMPLATE, 'res'):
        return Object.assign({}, state, {
            deleteInvoiceTemplate: Object.assign({}, state.deleteInvoiceTemplate, {
                loading: false,
                success: action.success,
            }),
        });

    case actionCreator(DELETE_INVOICE_TEMPLATE, 'err'):
        return Object.assign({}, state, {
            deleteInvoiceTemplate: Object.assign({}, state.deleteInvoiceTemplate, {
                loading: false,
                success: false,
                error: action.error,
            }),
        });

    default:
        return state;
    }
}
